import { PRIMARY_50, BLACK, PRIMARY_500, GRAY_500, GRAY_400 } from "../../constant/colors";

export const ActionsMenuStyle = `
    border-radius: 8px;
    padding: 0;
    width: 145px;
    .ant-dropdown-menu-item {
        padding: 8px 12px 8px 12px;
    }
    .ant-dropdown-menu-item:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    .ant-dropdown-menu-item:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }
    .ant-dropdown-menu-item:hover:not(.ant-dropdown-menu-item-disabled){
        background-color: ${PRIMARY_50};

    }
    .ant-dropdown-menu-item:nth-child(1):hover:not(.ant-dropdown-menu-item-disabled) svg rect{
            fill:${PRIMARY_50}
    }
    .ant-dropdown-menu-item {
        color: ${BLACK} ;
        font-size: 14px;
        font-weight: 400;

    }
    .ant-dropdown-menu-item {
        user-select: none;
    }
    .ant-dropdown-menu-item:hover:not(.ant-dropdown-menu-item-disabled) span{
        color: ${PRIMARY_500};

    }
    .ant-dropdown-menu-item:hover:not(.ant-dropdown-menu-item-disabled) span > .anticon {
        color: ${BLACK};
    }
    .ant-dropdown-menu-item:hover:not(.ant-dropdown-menu-item-disabled) .anticon-right {
        color: ${GRAY_500} !important;
    }
    .ant-dropdown-menu-item-disabled:hover {
        background-color: transparent !important;
        cursor: not-allowed !important;
    }
    .ant-dropdown-menu-item-disabled:hover span {
        color: ${GRAY_400} !important;
    }

    .ant-dropdown-menu-item[id*="export"]:hover:not(.ant-dropdown-menu-item-disabled) span > span svg {
        color: ${BLACK} !important;
    }
`;
